import { c as _c } from "react/compiler-runtime";
import type { ComparisonTableColumn } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { Box, Button } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
type ApplyNowCtaProps = {
  column: ComparisonTableColumn;
};
export default function ApplyNowCta(t0) {
  const $ = _c(19);
  const {
    column
  } = t0;
  const {
    marketplaceEntity,
    isPrimaryEntity
  } = column;
  const {
    details: t1,
    cta,
    ctaAnalytics,
    finishType
  } = marketplaceEntity;
  const {
    applyLink
  } = t1;
  const t2 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined;
  const t3 = cta.type !== EntityPlacementCtaTypeEnum.ApplyNow;
  let t4;
  if ($[0] !== cta.type) {
    t4 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH] : [];
    $[0] = cta.type;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = isPrimaryEntity ? "contained" : "outlined";
  let t6;
  if ($[2] !== cta.type) {
    t6 = [undefined, true].includes(cta?.type === EntityPlacementCtaTypeEnum.ApplyNow) ? <span aria-hidden="true" className="mask-icon mask-icon-open-in-new" style={{
      width: "1rem",
      height: "1rem"
    }} /> : undefined;
    $[2] = cta.type;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = isPrimaryEntity ? "none" : "underline";
  let t8;
  if ($[4] !== t7) {
    t8 = {
      fontWeight: "normal",
      border: 0,
      "&:hover": {
        border: 0,
        textDecoration: t7
      }
    };
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== cta.text || $[7] !== t5 || $[8] !== t6 || $[9] !== t8) {
    t9 = <Button tabIndex={-1} variant={t5} endIcon={t6} sx={t8}>{cta.text}</Button>;
    $[6] = cta.text;
    $[7] = t5;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== applyLink || $[12] !== ctaAnalytics || $[13] !== finishType || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t9) {
    t10 = <Box sx={_temp} width="100%"><CtaLink analytics={ctaAnalytics} type="APPLY_NOW_BUTTON" href={applyLink} rel={t2} target="_blank" isReview={t3} finishType={finishType} parameterActions={t4}>{t9}</CtaLink></Box>;
    $[11] = applyLink;
    $[12] = ctaAnalytics;
    $[13] = finishType;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
function _temp(t0) {
  const {
    palette
  } = t0;
  return {
    borderTop: `1px solid ${palette.neutral.light}`
  };
}